import React from 'react'
import './EditColumns.scss'
import PropTypes from 'prop-types'
import { CustomSelect } from '@components/common'
import { Button } from '@material-ui/core'

const EditColumns = props => {
  const propFieldKeys = props.dialogPropertyFields.propertyFields.map(
    prop => prop.value
  )
  const availableFieldsForSelection = props.dialogPropertyFields.allFields.filter(
    item => !propFieldKeys.includes(item.value)
  )
  const { dragIndex, propertyFields, reset } = props.dialogPropertyFields

  return (
    <>
      <div className="columnsContentNote">
        Select none to hide labels. To change the column order, drag and drop a
        field. Changes will be applicable to all properties.
      </div>
      <div className="columnsContentReset btn-reset">
        <Button
          className="btn cancel"
          id="unitMixDetails-reset"
          data-testid="columnsDetails-reset"
          variant="contained"
          size="large"
          disabled={!reset}
          onClick={props.handleReset}
        >
          <span className="reset">Reset</span>
        </Button>
      </div>
      <div
        className="editColumns-container"
        data-testid="editColumns-container"
      >
        {propertyFields.map((propertyField, index) => (
          <CustomSelect
            key={index}
            position={index}
            propertyField={propertyField}
            isMandatoryField={props.dialogPropertyFields.mandatoryFields.includes(
              propertyField.value
            )}
            availableFieldsForSelection={availableFieldsForSelection}
            handleSelectChange={props.handleSelectChange}
            isDragging={dragIndex === index}
            dragMode={dragIndex !== -1}
            onDragOver={props.onDragOver}
            onDragStart={props.onDragStart}
            onDrop={props.onDrop}
          />
        ))}
      </div>
    </>
  )
}

EditColumns.propTypes = {
  handleSelectChange: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
  handleReset: PropTypes.func,
  dialogPropertyFields: PropTypes.object
}

export default EditColumns
